var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58317 1.66602C5.229 1.66602 1.6665 5.22852 1.6665 9.58268C1.6665 11.4035 2.29984 13.1452 3.48734 14.5702L1.904 16.1535C1.58734 16.4702 1.58734 16.9452 1.904 17.2618C2.06234 17.4202 2.22067 17.4993 2.45817 17.4993H9.58317C13.9373 17.4993 17.4998 13.9368 17.4998 9.58268C17.4998 5.22852 13.9373 1.66602 9.58317 1.66602ZM6.4165 10.3743C5.9415 10.3743 5.62484 10.0577 5.62484 9.58268C5.62484 9.10768 5.9415 8.79102 6.4165 8.79102C6.8915 8.79102 7.20817 9.10768 7.20817 9.58268C7.20817 10.0577 6.8915 10.3743 6.4165 10.3743ZM9.58317 10.3743C9.10817 10.3743 8.7915 10.0577 8.7915 9.58268C8.7915 9.10768 9.10817 8.79102 9.58317 8.79102C10.0582 8.79102 10.3748 9.10768 10.3748 9.58268C10.3748 10.0577 10.0582 10.3743 9.58317 10.3743ZM12.7498 10.3743C12.2748 10.3743 11.9582 10.0577 11.9582 9.58268C11.9582 9.10768 12.2748 8.79102 12.7498 8.79102C13.2248 8.79102 13.5415 9.10768 13.5415 9.58268C13.5415 10.0577 13.2248 10.3743 12.7498 10.3743Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.bd88b618560a8f479415e6a1204ced1e.svg";
export { ForwardRef as ReactComponent };